(function($) {

    $(window).scroll(function() {
        if($(this).scrollTop() == "0") {
            $('#sticky-nav').removeClass('hidden');
        } else {
            $('#sticky-nav').addClass('hidden');
        }
    });


    $( "#sticky-nav" ).on( "mouseover", function() {
        $('#sticky-nav').removeClass('hidden');
    });


    $('#sticky-nav .nav-link').off('click').on('click', function(e) {

        e.preventDefault();

        var _href = $(this).attr('href');

        $('html,body').animate({scrollTop: $(_href).offset().top - 75}, 500);

    });


})(jQuery);